// extracted by mini-css-extract-plugin
export default {"control":"BackgroundMusic_control__n9G4W","note":"BackgroundMusic_note__NLE4C","playing":"BackgroundMusic_playing__3iYs5","music-pulse":"BackgroundMusic_music-pulse__Oqtdu"};